import { GridColumnMenu as MUIGridColumnMenu } from '@mui/x-data-grid-premium';
import { GridColumnMenuProps } from '../types/data-grid-props.type';

const GridColumnMenu: React.FC<GridColumnMenuProps> = ({ ...props }) => {
  return <MUIGridColumnMenu {...props} />;
};

export default GridColumnMenu;
